/** Party cups — packs of 5. KES 20 plain · +20 sticker · +10 custom name on sticker. */

export const PACK_SIZE = 5;
export const CUP_BASE_KES = 20;
export const STICKER_KES = 20;
export const CUSTOM_NAME_KES = 10;

/** @deprecated use STICKER_KES */
export const BRANDING_KES = STICKER_KES;

export const CUP_COLORS = [
    {
        id: "red",
        name: "Red",
        hex: "#DC2626",
        image: "/merch/cups/red.jpg",
    },
    {
        id: "green",
        name: "Green",
        hex: "#16A34A",
        image: "/merch/cups/green.jpg",
    },
    {
        id: "blue",
        name: "Blue",
        hex: "#2563EB",
        image: "/merch/cups/blue.jpg",
    },
    {
        id: "mustard",
        name: "Mustard",
        hex: "#CA8A04",
        image: "/merch/cups/mustard.jpg",
    },
    {
        id: "black",
        name: "Black",
        hex: "#18181B",
        image: "/merch/cups/black.jpg",
    },
];

export const EPL_TEAMS = [
    { id: "arsenal", name: "Arsenal", short: "ARS" },
    { id: "aston-villa", name: "Aston Villa", short: "AVL" },
    { id: "bournemouth", name: "Bournemouth", short: "BOU" },
    { id: "brentford", name: "Brentford", short: "BRE" },
    { id: "brighton", name: "Brighton", short: "BHA" },
    { id: "chelsea", name: "Chelsea", short: "CHE" },
    { id: "crystal-palace", name: "Crystal Palace", short: "CRY" },
    { id: "everton", name: "Everton", short: "EVE" },
    { id: "fulham", name: "Fulham", short: "FUL" },
    { id: "ipswich", name: "Ipswich", short: "IPS" },
    { id: "leicester", name: "Leicester", short: "LEI" },
    { id: "liverpool", name: "Liverpool", short: "LIV" },
    { id: "man-city", name: "Man City", short: "MCI" },
    { id: "man-united", name: "Man United", short: "MUN" },
    { id: "newcastle", name: "Newcastle", short: "NEW" },
    { id: "nottingham", name: "Nottingham Forest", short: "NFO" },
    { id: "southampton", name: "Southampton", short: "SOU" },
    { id: "tottenham", name: "Tottenham", short: "TOT" },
    { id: "west-ham", name: "West Ham", short: "WHU" },
    { id: "wolves", name: "Wolves", short: "WOL" },
];

export const MERCH_CONTACT = {
    email: "chidi@cheppar.co.ke",
    whatsapp: "254700000000",
};

/** Empty cup line — plain cup, no sticker, no name. */
export function emptyCupLine() {
    return { team: null, name: null };
}
